import React from "react";
import AccountPage from "./views/AccountPage";
import SideNavContainer from './SideNavContainer'
import LoginContainer from "./LoginContainer";

class AccountPageContainer extends React.Component {
  render() {
    console.log(this.props)

    let page = null

    if (!this.props.userLoggedIn) {
      // Show LogIn Page
      page = (
        <div>
          <SideNavContainer
            toggleSidebar={this.props.toggleSidebar}
            sidebarActive={this.props.sidebarActive}
          />
          <div className={this.props.sidebarActive ? "main-container" : "main-container expanded"}>
            <LoginContainer />
          </div>
        </div >
      )

    }
    else {
      page = (
        <div>
          <SideNavContainer
            toggleSidebar={this.props.toggleSidebar}
            sidebarActive={this.props.sidebarActive}
          />
          <div className={this.props.sidebarActive ? "main-container" : "main-container expanded"}>
            <h1>Account</h1>
            <p>TODO:: Maak een account pagina</p>
          </div>
        </div >
      )
    }

    return <AccountPage page={page} />;
  }
}

export default AccountPageContainer;
